<template>
  <div class="mentIndex">
    <div class="home_con_index">
      <div style="width:306px"></div>
      <div class="mentCon">
        <div class="ment_title">充电站信息</div>
        <img src="@/assets/ment/aa.png" alt="" />
         <img style="margin-top:0px;" src="@/assets/ment/bb.png" alt="" />
      </div>
    </div>
  </div>
</template>


<script>
import Ment from "@/components/ment";
export default {
  components: {
    Ment,
  },
};
</script>

<style scoped>
.home_con_index {
  display: flex;
  text-align: left;
  
}
.mentCon small {
  margin: 23px 0px 12px 0px;
  font-size: 12px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #5a6073;
  line-height: 12px;
}
.mentCon img {
  margin: 0px;
}
</style>


// WEBPACK FOOTER //
// src/page/document/documentc.vue